module.exports = __webpack_public_path__ + "static/media/primary-5.3a8e8b9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-5.jpg
// module id = 157
// module chunks = 0